<template>

  <div id='app'>

    <header>
        <!-- Socials -->
        <ul class="do-socials">
            <li><a href="https://www.facebook.com/mepauradi/" target="_blank"><img src="static/images/fb.svg" alt="Facebook"/></a></li>
            <li><a href="https://www.instagram.com/mepauradi/" target="_blank"><img src="static/images/insta.svg" alt="Facebook"/></a></li>
        </ul>

        <!-- Website Logo -->
        <div class="do-logo">
            <img src="static/images/pauradime.png" alt="Paura Di Me" />
        </div>
    </header>

    <main>

        <!-- Banner-->
        <div class="do-banner-wrap">

            <div class="do-banner-caption">
                <div class="do-banner-heading">
                    <p><a v-scroll-to="{
                      el: '#dynArticles',
                      onDone: function(element) {
                        // scrolling is done
                        $router.push('paura-di-conoscermi');
                      }
                      }">Paura di conoscermi?</a></p>
                    <p><a v-scroll-to="{
                      el: '#dynArticles',
                      onDone: function(element) {
                        // scrolling is done
                        $router.push('paura-di-usarmi');
                      }
                      }">Paura di usarmi?</a></p>
                    <p><a v-scroll-to="{
                      el: '#dynArticles',
                      onDone: function(element) {
                        // scrolling is done
                        $router.push('paura-di-cambiare');
                      }
                    }">Paura di cambiare?</a></p>
                    <p><a v-scroll-to="{
                      el: '#dynArticles',
                      onDone: function(element) {
                        // scrolling is done
                        $router.push('paura-di-numeri');
                      }
                      }">Paura dei numeri?</a></p>
                </div>
            </div>

            <!-- Banner Slider -->
            <div class="do-banner-slider">
                <slick
                  ref="slick" :options="slickOptions">
                  <div class="slide">
                    <img src="static/images/plastics/bottle.png" alt="Bottle" />
                  </div>
                  <div class="slide">
                    <img src="static/images/plastics/tube.png" alt="Tube" />
                  </div>
                  <div class="slide">
                    <img src="static/images/plastics/liquid_soap.png" alt="Liquid Soap" />
                  </div>
                  <div class="slide">
                    <img src="static/images/plastics/cup.png" alt="Cup" />
                  </div>
                   <div class="slide" >
                    <img src="static/images/plastics/pasta.png" alt="Pasta" />
                  </div>
                   <div class="slide" >
                    <img src="static/images/plastics/yogurt.png" alt="Yogurt" />
                  </div>
                </slick>
            </div>

            <!-- Scroll Down -->
            <a class="do-scroll-down" href="#" v-scroll-to="'#dynArticles'">
                <img src="static/images/mouse.png" alt="Scroll Down" />
                <img src="static/images/arrow.png" alt="Scroll Down" />
            </a>

        </div>
        <!-- / Banner -->

        <div class="do-page-content">

            <section id="dynArticles" class="dyn-section">
              <transition :name="transitionName" mode="out-in"
                v-on:before-leave="beforeLeave"
                v-on:enter="enter"
                v-on:after-enter="afterEnter"
                >
                <router-view/>
              </transition>
            </section>

        </div>
    </main>

    <footer>

      <div class="do-logos">
          <span class="do-logo">
              <progressive-img src="static/images/plasticeurope.png" alt="Plastic Europe" />
          </span>

          <span class="do-logo">
              <progressive-img src="static/images/footer-logo.png" alt="Plastic Europe" />
          </span>
        </div>
        <p>
          La plastica è un materiale prezioso e insostituibile che va valorizzato. Le imprese di PlasticsEurope Italia si impegnano affinché sia utilizzata, riciclata e recuperata in modo corretto.
        </p>

        <ul class="do-footer-menu">
            <li><a href="https://www.plasticseurope.org/it/privacy-policy" target="_blank">PRIVACY E POLICY</a></li>
            <li>
              <router-link to="fonti">
                FONTI
              </router-link>
            </li>
        </ul>

    </footer>

  </div>

</template>

  <style lang="scss">
    @import 'src/assets/css/bootstrap.scss';
    @import 'src/assets/css/lightslider.scss';
    @import 'src/assets/css/styles.scss';
    @import 'node_modules/slick-carousel/slick/slick.scss';
  </style>

<script>

const DEFAULT_TRANSITION = 'articles-anim';
import Slick from "vue-slick";

export default {
  name: 'App',
  data() {
    return {
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION,
      slickOptions: {
        //options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: true,
        accessibility: true,
        adaptiveHeight: false,
        arrows: false,
        dots: true,
        draggable: true,
        edgeFriction: 0.3,
        swipe: true
      }
    }
  },
  components: {
    'slick': Slick
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;

      if (transitionName === 'slide') {
        transitionName = 'slide-left';
      }
      if (transitionName === 'slide-reverse') {
        transitionName = 'slide-right';
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;

      next();
    });
  },
  methods: {
    beforeLeave(element) {
      // this.prevHeight = getComputedStyle(element).height;
      // const articleInfo = element.querySelectorAll('.do-article-info .progressive-background');
      // if(articleInfo[0] && window.innerWidth > 990){
      //   articleInfo[0].style.height = this.prevHeight;
      // }
    },
    enter(element) {
      // const { height } = getComputedStyle(element);
      // if(articleInfo[0] && window.innerWidth > 990){
      //   element.parentNode.style.height = this.prevHeight;
      // }
      // console.log(element.parentNode);
    },
    afterEnter(element) {
      // const { height } = getComputedStyle(element);
      // if(articleInfo[0] && window.innerWidth > 990){
      //   element.parentNode.style.height = height;
      // }
      // console.log(element.parentNode);
    },
  }
}
</script>

<style>

/* @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.min.css'; */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.2s;
  transition-property: height, opacity, transform;
  transition-timing-function: ease-in;
  overflow: hidden;
  background: #ffffff;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translateX(-20px);
}

</style>



// WEBPACK FOOTER //
// src/App.vue